// Pure, dependency-free classifier. Given a link URL, decide whether it belongs
// in the Repository pane or the Documentation pane. The guess is a default the
// user can always override; the server only validates the submitted kind.
//
// Returns 'repository' | 'doc', or null when the URL is blank (no chip shown).

const KNOWN_PUBLIC_HOSTS = ['github.com', 'gitlab.com', 'bitbucket.org'];
const HOST_KEYWORDS = /gitea|gogs|bitbucket/;

function hasScheme(str) {
  return /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(str);
}

// Two path segments (`org/repo`) after trimming slashes and an optional trailing
// `.git`. A 2-segment path can't be a deeper sub-page (wiki/blob/tree/...), so
// this is exactly "org/repo and no more".
function isRepoRootPath(pathname) {
  const trimmed = pathname.replace(/^\/+|\/+$/g, '').replace(/\.git$/, '');
  const segments = trimmed.split('/').filter(Boolean);
  return segments.length === 2;
}

function isGitHost(hostname) {
  const bare = hostname.replace(/^www\./, '');
  if (KNOWN_PUBLIC_HOSTS.includes(bare)) return true;

  const firstLabel = bare.split('.')[0];
  if (firstLabel === 'docs') return false;

  const labelPrefix =
    firstLabel === 'git' ||
    firstLabel.startsWith('gitlab') ||
    firstLabel.startsWith('git-');

  return labelPrefix || HOST_KEYWORDS.test(bare);
}

export function classifyLink(input) {
  if (input == null) return null;
  const raw = String(input).trim();
  if (raw === '') return null;

  let parsed;
  try {
    parsed = new URL(hasScheme(raw) ? raw : `https://${raw}`);
  } catch {
    return 'doc';
  }

  if (!parsed.hostname) return 'doc';

  return isRepoRootPath(parsed.pathname) && isGitHost(parsed.hostname)
    ? 'repository'
    : 'doc';
}
